import { AssetLocationInterface } from "../../models/AssetModel/AssetLocation";
import client from "../client";

class AssetLocationsService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/AssetLocations`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<AssetLocationInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetLocations/getbyid/${id}`;

      const { data } = await client.get<AssetLocationInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(customer: AssetLocationInterface) {
    try {
      let url = `/api/AssetLocations`;

      const { data } = await client.post<AssetLocationInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetLocationInterface) {
    try {
      let url = `/api/AssetLocations/update/${id}`;

      const { data } = await client.post<AssetLocationInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetLocations/remove/${id}`;
      await client.post<AssetLocationInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetLocationsService();
